import { L10nConfig } from 'angular-l10n';

import { i18nAsset } from './i18n';

export const l10nConfig: L10nConfig = {
  format: 'language-region',
  providers: [{ name: 'app', asset: i18nAsset }],
  fallback: false,
  cache: true,
  keySeparator: '.',
  defaultLocale: {
    language: 'ar-SA',
    currency: 'USD',
    units: { length: 'kilometer' },
  },
  schema: [
    {
      locale: {
        language: 'en-US',
        currency: 'USD',
        units: { length: 'kilometer' },
      },
      dir: 'ltr',
      text: 'United States',
    },
    {
      locale: {
        language: 'ar-SA',
        currency: 'USD',
        units: { length: 'kilometer' },
      },
      dir: 'rtl',
      text: 'Arabic',
    },
  ],
};
